class MapResult {
  map(data) {
    throw new Error("Método map debe ser implementado por la subclase");
  }
}

export class ModelMapResult extends MapResult {
  map(data) {
    let modelsMap = data.map(model => {
      const {
        data: {
          __type: { inputFields, name }
        }
      } = model;

      return { [name]: inputFields };
    });

    return modelsMap;
  }
}

export class OperationMapResult extends MapResult {
  map({ keys, results }) {
    let opsMap = keys.map(key => {
      const match = results.find(result => Object.hasOwn(result, key));

      return { [key]: match[key] };
    });

    return opsMap;
  }
}
